<template>
  <div>
    <section
      id="page-title"
      class="page-title-parallax page-title-dark page-title-right"
      style="
        padding: 550px 0px 300px;
        background-image: url('/assets/img/test1.jpg');
        background-size: cover;
        background-position: 50% -27.4px;
      "
      data-stellar-background-ratio="0.2"
    >
      <div class="container">
        <h1>IDS</h1>
        <span>COMPETITION TEAM</span>
      </div>
    </section>

    <section id="content">
      <div>
        <div class="container" style="padding-top: 20px">
          <div class="row">
            <div class="col-md-12">
              <h3>Competition Team</h3>
              <p>
                Infinity Dance Studio offers competitive dance teams for
                children ages 5 through 18. Team members are selected through an
                annual audition process. Our studio's goal is to provide as many
                dancers as possible the opportunity to continuously challenge
                themselves in an different environment while providing the same
                superior dance education we are known to offer to all of our
                students. Auditions for our teams will be held during the Summer
                of the current year for the next competition season.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <!-- <div>
                    <div class="container">
                        <div class="row">
                            <div class="center topmargin-lg">
                                <h3>SPONSORS</h3>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Mary Jane" src="@/assets/img/sponsors/logonew15.png" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="John Doe" src="@/assets/img/sponsors/logonew1.png" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Mary Jane" src="@/assets/img/sponsors/logonew16.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Irasema Berreiro" src="@/assets/img/sponsors/logonew2.png" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Mary Jane" src="@/assets/img/sponsors/logonew3.png" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Mary Jane" src="@/assets/img/sponsors/logonew4.png" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Mary Jane" src="@/assets/img/sponsors/logonew5.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Mary Jane" src="@/assets/img/sponsors/logonew6.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Mary Jane" src="@/assets/img/sponsors/logonew7.png" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Mary Jane" src="@/assets/img/sponsors/logonew8.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Mary Jane" src="@/assets/img/sponsors/logonew18.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Mary Jane" src="@/assets/img/sponsors/logonew10.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Mary Jane" src="@/assets/img/sponsors/logonew11.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Mary Jane" src="@/assets/img/sponsors/logonew12.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Mary Jane" src="@/assets/img/sponsors/logonew13.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Mary Jane" src="@/assets/img/sponsors/logonew14.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-8 ">
                                <div class="team">
                                    <div class="team-image">
                                        <img alt="Mary Jane" src="@/assets/img/sponsors/logonew17.jpg" />
                                    </div>
                                    <div class="team-desc team-desc-bg">
                                        <div class="team-title">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            
                           
        
                           
                           
                        </div>
                    </div>
                </div>
            </div> -->
      <div class="container">
        <div class="row">
          <div class="center topmargin-lg">
            <h3>SPONSORS</h3>
          </div>
          <div
            v-for="sponsor in sponsorsArray"
            :key="sponsor.id"
            class="col-md-4 col-sm-8"
          >
            <div class="team">
              <div class="team-image">
                <img alt="Mary Jane" :src="sponsor" />
              </div>
              <div class="team-desc team-desc-bg">
                <div class="team-title"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import sp1 from "@/assets/img/sponsors/sponsorA06.png";
import sp2 from "@/assets/img/sponsors/sponsorA18.png";
import sp3 from "@/assets/img/sponsors/sponsorA22.png";
import sp4 from "@/assets/img/sponsors/sponsorA29.png";
import sp5 from "@/assets/img/sponsors/sponsorB14.png";
import sp6 from "@/assets/img/sponsors/sponsorB16.png";
import sp7 from "@/assets/img/sponsors/sponsorB17.png";
import sp8 from "@/assets/img/sponsors/sponsorB24.png";
import sp9 from "@/assets/img/sponsors/sponsorC09.png";
import sp10 from "@/assets/img/sponsors/sponsorC11.png";
import sp11 from "@/assets/img/sponsors/sponsorC23.png";
import sp12 from "@/assets/img/sponsors/sponsorE32.png";
import sp13 from "@/assets/img/sponsors/sponsorF29.png";
import sp14 from "@/assets/img/sponsors/sponsorH15.png";
import sp15 from "@/assets/img/sponsors/sponsorI33.png";
import sp16 from "@/assets/img/sponsors/sponsorJ20.png";
import sp17 from "@/assets/img/sponsors/sponsorJ21.png";
import sp18 from "@/assets/img/sponsors/sponsorL05.png";
import sp19 from "@/assets/img/sponsors/sponsorL10.png";
import sp20 from "@/assets/img/sponsors/sponsorM08.png";
import sp21 from "@/assets/img/sponsors/sponsorM26.png";
import sp22 from "@/assets/img/sponsors/sponsorN27.png";
import sp23 from "@/assets/img/sponsors/sponsorN31.png";
import sp24 from "@/assets/img/sponsors/sponsorO07.png";
import sp25 from "@/assets/img/sponsors/sponsorO28.png";
import sp26 from "@/assets/img/sponsors/sponsorO30.png";
import sp28 from "@/assets/img/sponsors/sponsorR20.png";
import sp29 from "@/assets/img/sponsors/sponsorS04.png";
import sp30 from "@/assets/img/sponsors/sponsorS13.png";
import sp31 from "@/assets/img/sponsors/sponsorT25.png";
import sp32 from "@/assets/img/sponsors/sponsorV03.png";
import sp33 from "@/assets/img/sponsors/sponsorV12.png";
import sp34 from "@/assets/img/sponsors/sponsorW01.png";
import sp35 from "@/assets/img/sponsors/sponsorW02.png";
import sp36 from "@/assets/img/sponsors/sponsorW24.png";
import sp37 from "@/assets/img/sponsors/sponsorX19.png";

export default {
  data() {
    return {
      sponsorsArray: [
        sp1,
        sp2,
        sp3,
        sp4,
        sp5,
        sp6,
        sp7,
        sp8,
        sp9,
        sp10,
        sp11,
        sp12,
        sp13,
        sp14,
        sp15,
        sp16,
        sp17,
        sp18,
        sp20,
        sp21,
        sp22,
        sp23,
        sp24,
        sp25,
        sp26,
        sp28,
        sp29,
        sp30,
        sp31,
        sp32,
        sp33,
        sp34,
        sp35,
        sp36,
        sp37,
      ],
    };
  },
  name: "Competition",
  components: {},
};
</script>

<style scoped>
h1 {
  color: black;
}
</style>
